import {nextTick} from 'vue'

export const Route = Symbol("Route")
export const Overview = Symbol("Overview")
export const Ship = Symbol("Ship")
export const Promotions = Symbol("Promotions")
export const Cabins = Symbol("Cabins")

export const NAV_DICT = {
    Route,
    Overview,
    Ship,
    Promotions,
    Cabins,
}

export const anchor = name => {
    return name.toLowerCase()
}

export const click_scrollTo = name => {
 // на момент Layout внутренности еще не определены если layout уже отрендерен
    nextTick( () => click_scrollToReal(name) )
}

const scrollToEl = name => {
    const id = anchor(name)
    const el = document.getElementById(id)
    if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    return el ? true : false
}

const click_scrollToReal = (name) => {
    const is = scrollToEl(name)
    // грязный хак. Проброс меняет страничку из-за левого блока и происходит сползание
    // восстанавливаем
    if (is && name === "Cabins" ) {
        setTimeout( scrollToEl, 500, name )
    }
}
